import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketDeliveryCreationComponent } from './ticket-delivery-creation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgSelectModule } from '@ng-select/ng-select';
import { PosAttachmentsModule } from 'src/app/shared/pos-attachments/pos-attachments.module';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { NgxMaskModule } from 'ngx-mask';
import { UiSwitchModule } from 'ngx-ui-switch';



@NgModule({
  declarations: [TicketDeliveryCreationComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AccordionModule,
    NgSelectModule,
    PosAttachmentsModule,
    PosTableModule,
    NgxMaskModule,
    FormsModule,
    UiSwitchModule
  ],
  exports: [
    TicketDeliveryCreationComponent
  ]
})
export class TicketDeliveryCreationModule { }
